import { useQuery } from "react-query";
import { getBillsOfficeHierarchy } from "../../../../../actions/CarrierAgreementMgmt/OfficeSettings";

const useGetBillsOfficeHierarchy = () => {
  return useQuery(["GetOfficeHierarchyReport"], getBillsOfficeHierarchy, {
    refetchOnWindowFocus: false,
  });
};
export default useGetBillsOfficeHierarchy;
